export default __webpack_public_path__ + "static/media/logo.00ce5753.png";